export const stripBadChars = stringToStrip =>
    stringToStrip
        .toString()
        .replace(/</g, ' ')
        .replace(/>/g, ' ')
        .trim();

// TODO: This function does not work. The backend returns invalid data in initData.searchParams ("1" instead of the string value) :-(
// export const getActiveSearchParams = searchParamsAsString => {
//     const searchParams = JSON.parse(searchParamsAsString);
//     const dontKeepTheseParams = ['q', 'categoryId', 'paging', 'spage'];
//     const activeSearchParams = Object.keys(searchParams).reduce((acc, currentValue) => {
//         if (searchParams[currentValue] && searchParams[currentValue] !== null && dontKeepTheseParams.indexOf(currentValue) < 0) {
//             // acc[currentValue] = searchParams[currentValue];
//             acc.push(`${currentValue}=${searchParams[currentValue]}`)
//         }
//         return acc;
//     }, []);
//     console.log('searchParams', searchParams);
//     console.log('activeSearchParams', activeSearchParams)
//     debugger;
//     return activeSearchParams.join('&');
// }

const _getQueryStringFromSearchUrl = searchUrl => {
    if (searchUrl && searchUrl.indexOf('?') > -1) {
        return searchUrl.split('?')[1];
    }
    return '';
};

export const getExistingQueryString = searchUrl => {
    const query = _getQueryStringFromSearchUrl(searchUrl),
        queryVars =
            query.length > 0 && query.indexOf('&') > -1 ? query.split('&') : [],
        dontKeepTheseParams = ['q', 'categoryId', 'paging', 'spage'];

    let pair,
        keepTheseParams = [],
        keptQueryString = '';

    queryVars.forEach(function(queryVar) {
        pair = queryVar.split('=');
        if (dontKeepTheseParams.indexOf(pair[0]) < 0) {
            keepTheseParams.push(pair[0] + '=' + pair[1]);
        }
    });

    if (keepTheseParams) {
        keptQueryString = keepTheseParams.join('&');
    }

    return keptQueryString;
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search/helper.js